<div class="sparkline-container" [style.height.px]="height">
    <canvas #sparkeline height="{{height}}" width="{{width}}"></canvas>
</div>
<div *ngIf="tooltipPosition" [ngStyle]="{left: tooltipPosition?.left + 'px', top: tooltipPosition?.top+ 'px'}"
    class="sparkline-tooltip" #tooltip="matTooltip" [matTooltip]="tooltipText" [matTooltipPosition]="'above'"
    matTooltipClass="marker-tooltip" matTooltipShowDelay="1000"></div>